import type { Mission } from '../missions.ts'

export const usaf: Mission = {
  id: "usaf",
  name: "U.S. Air Force",
  short: "USAF",
  kind: "subagency",
  parent: "dod",
  url: "https://www.af.mil/",
  established: 1947,
  palette: {
    primary: "#00308f",
    secondary: "#a6a6a8",
    accent: "#fab70a",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.trademark.af.mil/Branding/Air-Force-Symbol/",
  },
  motif: "plane",
  mission: {
    text: "The mission of the United States Air Force is to fly, fight, and win...airpower anytime, anywhere.",
    url: "https://www.af.mil/About-Us/",
  },
  fact: {
    text: "The Air Force became a separate branch of the military on September 18, 1947, under the National Security Act of 1947.",
    url: "https://www.dvidshub.net/image/9471524",
  },
  seal: {
    file: "public/seals/usaf.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_the_Air_Force.svg",
  },
  logo: {
    file: "public/logos/usaf.svg",
    source: "https://commons.wikimedia.org/wiki/File:US_Air_Force_Logo_Solid_Colour.svg",
  },
  identifier: {
    about: "https://www.af.mil/About-Us/",
    accessibility: "https://www.af.mil/Accessibility/",
    foia: "https://www.compliance.af.mil/",
    noFear: "https://www.af.mil/Equal-Opportunity/AS/",
    oig: "https://www.afinspectorgeneral.af.mil/",
    performance: "https://www.af.mil/Airpower-4-America/",
    privacy: "https://www.compliance.af.mil/",
  },
  media: {
    photos: [
      {
        file: "/media/usaf-b2-st-louis.jpg",
        small: "/media/usaf-b2-st-louis-sm.jpg",
        alt: "A B-2 Spirit stealth bomber flies low over downtown St. Louis, with the Gateway Arch and city streets below.",
        title: "B-2 Spirit flies over the Gateway Arch, St. Louis, August 10, 2006",
        creator: "Tech. Sgt. Justin D. Pyle, U.S. Air Force",
        source: "https://commons.wikimedia.org/wiki/File:US_Air_Force_060810-F-6701P-003_B-2_Spirit_flies_over_St._Louis.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usaf-f22-twilight.jpg",
        small: "/media/usaf-f22-twilight-sm.jpg",
        alt: "An F-22 Raptor in dark silhouette banks through towering golden clouds at twilight.",
        title: "F-22 Raptor twilight demonstration, EAA AirVenture Oshkosh, July 28, 2019",
        creator: "2nd Lt. Samuel Eckholm, U.S. Air Force",
        source: "https://commons.wikimedia.org/wiki/File:F-22_Raptor_flying_at_twilight_190728-F-VA182-1014.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/usaf-loop.webm",
      mp4: "/media/usaf-loop.mp4",
      poster: "/media/usaf-loop-poster.jpg",
      title: "A KC-135 Stratotanker refuels F-16 Thunderbirds en route to Super Bowl LI, February 3, 2017",
      creator: "Senior Airman Joshua Crawley, U.S. Air Force",
      source: "https://commons.wikimedia.org/wiki/File:USAF_Thunderbirds_Refueling_enroute_to_Super_Bowl_LI.webm",
      license: "Public domain (U.S. government work)",
    },
  },
}
